module.exports = __webpack_public_path__ + "static/media/plus-alt.85aa9232.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/plus-alt.svg
// module id = 553
// module chunks = 0